// extracted by mini-css-extract-plugin
module.exports = {"headImg":"_6520","container":"_11312","station":"_19887","headtitle":"_11016","list":"_4415"};